import { useState, useEffect } from "react";
import { Modal, Form, Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import Api from "../../admin/components/api/Api";
import Notification, { showToast } from "./notification/Notification";
import LocationSelector from "../customer/LocationSelector";

const LocationCompletionModal = () => {
  const loggedInUser = useSelector((state) => state.auth.user);
  const userId = loggedInUser?.user?.id;

  const [showModal, setShowModal] = useState(false);
  const [locationValue, setLocationValue] = useState({
    country: "",
    state: "",
    city: "",
    area: "",
  });
  const [profile, setProfile] = useState({ id: userId });

  const getDetailsApi = Api({ url: `admin/user/id/${userId}` });
  const editDetailsApi = Api({ url: `admin/editUser` });

  useEffect(() => {
    if (userId) {
      fetchUserData();
    }
  }, [userId]);

  const fetchUserData = async () => {
    try {
      const responseData = await getDetailsApi.fetchData();
      const data = responseData.data.user;
      const currentCountryId = data.cities?.[0]?.state?.country?.id || "";
      const currentStateId = data.states?.[0]?.id || "";
      const currentCityId = data.cities?.[0]?.id || "";

      setLocationValue({
        country: currentCountryId ? String(currentCountryId) : "",
        state: currentStateId ? String(currentStateId) : "",
        city: currentCityId ? String(currentCityId) : "",
        area: "",
      });
      setProfile({
        id: userId,
        first_name: data.first_name,
        last_name: data.last_name,
        country_id: currentCountryId ? String(currentCountryId) : "",
        state_id: currentStateId ? String(currentStateId) : "",
        city_id: currentCityId ? String(currentCityId) : "",
      });

      setShowModal(!data.cities?.[0]);
    } catch (error) {
      console.error("Error fetching user details:", error);
    }
  };

  const handleLocationChange = (updatedValue) => {
    setLocationValue(updatedValue);
    setProfile((currentProfile) => ({
      ...currentProfile,
      country_id: updatedValue.country || "",
      state_id: updatedValue.state || "",
      city_id: updatedValue.city || "",
      area_id: updatedValue.area || "",
    }));
  };

  const handleSkipClick = () => {
    setShowModal(false);
  };

  const handleModalClose = () => {
    setShowModal(false);
  };

  const handleProfileSubmit = async (e) => {
    e.preventDefault();

    try {
      const responseData = await editDetailsApi.editData(profile);
      if (responseData.data.statusType === "SUCCESS") {
        showToast("Details Updated Successfully", { type: "success" });
        setShowModal(false); // close modal after save
      }
    } catch {
      showToast("Error Occurred", { type: "error" });
    }
  };

  return (
    <Modal
      show={showModal}
      onHide={handleModalClose}
      centered
      backdrop="static"
    >
      <Notification />
      <Modal.Header>
        <Modal.Title>Complete Your Profile</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleProfileSubmit}>
          <Form.Group className="mb-4">
            <LocationSelector
              value={locationValue}
              onChange={handleLocationChange}
              levels={["state", "city"]}
            />
          </Form.Group>

          <div className="d-flex justify-content-between pt-4">
            <Button variant="secondary" onClick={handleSkipClick}>
              Skip
            </Button>
            <Button type="submit" variant="primary">
              Save & Continue
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default LocationCompletionModal;
